/**
 * Created by eriksundqvist on 11/10/16.
 */
import axios from 'axios';
import Service from '../service/service';
import InvoiceUserEntity from './invoice-user-entity';

class InvoiceUserService extends Service {

  hydrate (invoiceUser) {
    return new InvoiceUserEntity(
      invoiceUser.attributes.travel,
      invoiceUser.attributes.co,
      invoiceUser.attributes.street,
      invoiceUser.attributes.zip,
      invoiceUser.attributes.city,
      invoiceUser.attributes.country,
      invoiceUser.attributes.invoice_id,
      invoiceUser.attributes.user_id,
      invoiceUser.attributes.allowance,
      invoiceUser.attributes.taxkey_id,
      invoiceUser.attributes.total,
      invoiceUser.attributes.first_name,
      invoiceUser.attributes.last_name,
      invoiceUser.attributes.account_clearing_number,
      invoiceUser.attributes.account_number,
      invoiceUser.attributes.salary_payed_date,
      invoiceUser.attributes.express_payment,
      invoiceUser.attributes.taxkey_name,
      invoiceUser.attributes.save_vacation_pay,
      invoiceUser.attributes.save_itp,
      invoiceUser.attributes.itp_rate,
      null, // calculation
      invoiceUser.attributes.gross,
      invoiceUser.attributes.salary_net
    );
  }

  hydrateCollection (data, invoiceOwnerId) {
    var invoiceUsers = [];

    const sortedInvoiceUsersData = [
      ...data.filter((invoiceUser) => +invoiceUser.attributes.user_id === +invoiceOwnerId),
      ...data.filter((invoiceUser) => +invoiceUser.attributes.user_id !== +invoiceOwnerId)
    ];

    for (let i = 0; i < sortedInvoiceUsersData.length; i++) {
      invoiceUsers.push(this.hydrate(sortedInvoiceUsersData[i]));
    }

    return invoiceUsers;
  }

  getById (invoiceId) {
    return axios.get('backend://invoice-users/' + invoiceId)
      .then((response) => {
        return this.hydrate(response.data.data);
      });
  }
}

export default new InvoiceUserService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-user-service.js
 **/